<template>
	<div class="inner-filed">
		<common-layout>
			<div slot="header">
				<h3>内部会议</h3>
			</div>
			<div slot="container">
				<div class="inner-filed.header">
					<el-button type="success" size="mini" class="inner-filed.addBtn" @click="openInnerModal('')">发起会议</el-button>
					<el-button type="info" size="mini" class="inner-filed.addBtn" @click="exportOut" :disabled="tableData.length==0">导出</el-button>
					<section>
						<el-input placeholder="请输入会议名称" v-model="searchValue" class="input-with-select" clearable @change="search">
							<el-button slot="append" icon="el-icon-search" @click="search"></el-button>
						</el-input>
					</section>
					<div class="inner-filed.header.item">
						<label>类型:</label>
						<el-select v-model="typeVal" placeholder="请选择" clearable @change="search">
							<el-option label="全部" value=""></el-option>
							<el-option v-for="item in typeOptions" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
						</el-select>
					</div>
					<div class="inner-filed.header.item">
						<label>会议室:</label>
						<el-select v-model="areaVal" placeholder="请选择" clearable @change="search">
							<el-option label="全部" value=""></el-option>
							<el-option v-for="item in addressOptions" :key="item.id" :label="item.fieldName" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="inner-filed.header.item">
						<label>状态:</label>
						<el-select v-model="statusVal" placeholder="请选择" clearable @change="search">
							<el-option label="全部" value=""></el-option>
							<el-option label="未开始" :value="1"></el-option>
							<el-option label="进行中" :value="2"></el-option>
							<el-option label="已结束" :value="3"></el-option>
						</el-select>
					</div>
					<div class="inner-filed.header.item">
						<el-date-picker v-model="dateVal" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
						 format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable @change="search">
						</el-date-picker>
					</div>
				</div>
				<div class="inner-filed.table">
					<el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
						<el-table-column type="index" label="序号" align="center" width="90">
							<template slot-scope="scope">
								<span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="fieldName" label="会议室" align="center"></el-table-column>
						<el-table-column prop="name" label="会议名称" align="center"></el-table-column>
						<el-table-column prop="typeName" label="会议类型" align="center"></el-table-column>
						<el-table-column prop="unit" label="预约部门" width="180" align="center"></el-table-column>
						<el-table-column prop="people" label="预约人" align="center"></el-table-column>
						<el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
						<el-table-column label="会议状态" align="center">
							<template slot-scope="scope">
								<el-tag type="warning" v-show="new Date(scope.row.startTime) > new Date()">未开始</el-tag>
								<el-tag type="success" v-show="new Date() >= new Date(scope.row.startTime) && new Date() <= new Date(scope.row.endTime)">进行中</el-tag>
								<el-tag type="info" v-show="new Date(scope.row.endTime) < new Date()">已结束</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="left" width="300">
							<template slot-scope="scope">
								<el-button style="margin-bottom: 5px;" size="mini" @click="openInnerModal(scope.row)">查看预约</el-button>
								<el-button style="margin-bottom: 5px;" size="mini" type="danger" v-show="new Date(scope.row.startTime) > new Date() || new Date(scope.row.endTime) < new Date()"
								 @click="deleteEvent(scope.row)">删除预约</el-button>
								<el-button size="mini" type="primary" @click="rePreviewEvent(scope.row)">再次预约</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!-- 分页 -->
					<div class="pagination">
						<div class="grid-content bg-purple-light">
							<el-pagination @current-change="handleCurrentChange" :hide-on-single-page="true" layout="total, prev, pager, next,jumper"
							 :total="total" :current-page.sync="current_page" :page-size="per_page"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</common-layout>

		<!-- 内部预约 -->
		<el-dialog title="内部会议预约" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal='false'>
			<el-form :model="form" :rules="innerFormRules" ref="innerFormRule">
				<el-form-item label="会议名称:" :label-width="formLabelWidth" class="rowItem +add-button" prop="name">
					<el-input v-model="form.name" autocomplete="off" :disabled="operationType == 'edit'"></el-input>
				</el-form-item>
				<el-form-item label="会议类型:" :label-width="formLabelWidth" class="rowItem +add-button" prop="typeId">
					<el-select v-model="form.typeId" placeholder="请选择会议类型" :disabled="operationType == 'edit'">
						<el-option v-for="(item,index) in typeOptions" :key="item.id" :label="item.typeName" :value="item.id">
						</el-option>
					</el-select>
					<el-button type="primary" size="mini" @click="addActityType">+新增</el-button>
				</el-form-item>
				<el-form-item label="会议室:" :label-width="formLabelWidth" class="rowItem" prop="fieldId">
					<el-select v-model="form.fieldId" placeholder="请选择" :disabled="operationType == 'edit'" @change="siteEvent">
						<el-option v-for="item in addressOptions" :key="item.id" :label="item.fieldName" :value="item.id" :disabled="item.isCan != 1">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="预约部门:" :label-width="formLabelWidth" class="rowItem" prop="unit">
					<el-input v-model="form.unit" autocomplete="off" :disabled="operationType == 'edit'"></el-input>
				</el-form-item>
				<el-form-item label="预约人:" :label-width="formLabelWidth" class="rowItem" prop="people">
					<el-input v-model="form.people" autocomplete="off" :disabled="operationType == 'edit'"></el-input>
				</el-form-item>
				<el-form-item label="联系电话:" :label-width="formLabelWidth" prop="phone" class="rowItem">
					<el-input v-model="form.phone" autocomplete="off" :disabled="operationType == 'edit'"></el-input>
				</el-form-item>
				<el-row>
					<el-col :span="24">
						<el-form-item label="预约时间:" :label-width="formLabelWidth" prop="time">
							<input v-model="form.time" hidden></input>
							<dateCanalder isSingle=1 :fixedData="selectDates" :selectDateType="operationType" :isSelectDate="isSelectDate"
							 @userSelectData="userSelectData"></dateCanalder>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
          <el-col :span="24">
					<el-form-item label="预约时间段:" :label-width="formLabelWidth" prop="remarkTime">
						<input type="text" v-model="form.remarkTime" hidden="hidden">
						<el-col :span="8">
							<el-time-picker arrow-control v-model="form.startTime" class="+date-box" format='HH:mm' value-format="HH:mm"
							 placeholder="开始时间" :disabled="operationType == 'edit' || form.time ==''" :picker-options="{
							       selectableRange:`${startRange} -${form.endTime ? form.endTime+':00' : endRange}`
							    }"></el-time-picker>
						</el-col>
						<el-col :span="8">
							<el-time-picker arrow-control class="+date-box" placeholder="结束时间" v-model="form.endTime" format='HH:mm'
							 value-format="HH:mm" :disabled="operationType == 'edit' || form.time ==''" :picker-options="{
							      selectableRange:`${form.startTime ? form.startTime+':00' : startRange}-${endRange}`
							    }">
							</el-time-picker>
						</el-col>

					</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="参会人员详情:" :label-width="formLabelWidth" class="rowItem --detailBtn" v-show="operationType != 'edit'">
					<el-button type="success" @click="addMember">新增</el-button>
					<!-- <el-button type="danger">导入</el-button> -->
				</el-form-item>
				<el-form-item label="是否短信通知:" :label-width="formLabelWidth" prop="isMessage" :class="{'rowItem':operationType != 'edit'}">
					<el-radio-group v-model="form.isMessage" :disabled="operationType == 'edit'">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="2">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<div class="form-table">
						<el-table :data="innerTable" style="width: 100%" :header-cell-style="headerStyle">
							<el-table-column type="index" label="序号" align="center"></el-table-column>
							<el-table-column prop="username" label="参会人员姓名" align="center"></el-table-column>
							<el-table-column label="部门" align="center" width="300">
								<template slot-scope="scope">
									{{scope.row.department ? scope.row.department:'--'}}
								</template>
							</el-table-column>
							<el-table-column label="职位" align="center">
								<template slot-scope="scope">
									{{scope.row.position ? scope.row.position:'--'}}
								</template>
							</el-table-column>
							<el-table-column prop="phone" label="手机号" align="center"></el-table-column>
							<el-table-column label="备注" align="center">
								<template slot-scope="scope">
									{{scope.row.remark ? scope.row.remark:'暂无'}}
								</template>
							</el-table-column>
							<el-table-column label="操作" align="center" v-if="operationType != 'edit'">
								<template slot-scope="scope">
									<el-button style="margin-bottom: 5px;" type="danger" size="mini" @click.native.prevent="deleteInnerRow(scope.$index, innerTable)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer" v-if="operationType != 'edit'">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm('innerFormRule')">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 新增 -->
		<!--<el-dialog title="新增内部人员" :visible.sync="addDialogFormVisible" :close-on-click-modal='false'>
			<el-form :model="addForm" :rules="addRules" ref="addRuleForm">
				<el-form-item label="姓名" :label-width="formLabelWidth" prop="id">
					<el-select v-model="addForm.id" placeholder="请选择参会人员姓名" :disabled="operationType == 'edit'" @change="fillUserData">
						<el-option v-for="(item,index) in allUsers" :key="item.id" :label="item.username" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="部门" :label-width="formLabelWidth" prop="department">
					<el-input v-model="addForm.department" autocomplete="off" disabled></el-input>
				</el-form-item>
				<el-form-item label="职位" :label-width="formLabelWidth" prop="position">
					<el-input v-model="addForm.position" autocomplete="off" disabled></el-input>
				</el-form-item>
				<el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
					<el-input v-model="addForm.phone" autocomplete="off" disabled></el-input>
				</el-form-item>
				<el-form-item label="备注" :label-width="formLabelWidth">
					<el-input v-model="addForm.remark" autocomplete="off" type="textarea" disabled></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addDialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmAdd('addRuleForm')">确 定</el-button>
			</div>
		</el-dialog> -->
		<!-- 添加备注-->
		<el-dialog title="备注详情" :visible.sync="centerDialogVisible" width="30%" center :close-on-click-modal='false'>
			<el-form :model="formDesc" label-width="80px" :rules="formDescRule" ref="formDescRule">
				<el-form-item label="备注" prop="desc">
					<el-input v-model="formDesc.desc" autocomplete="off" type="textarea"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addDesc">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 添加活动类型 -->
		<el-dialog :visible.sync="dialogTypeVisible" title="活动类型" width="30%" :close-on-click-modal='false'>
			<el-form :model="acTypeForm" :rules="acTypeFormRule" ref="acTypeForm">
				<el-form-item label="类型名称" :label-width="formLabelWidth" prop="typeName">
					<el-input v-model="acTypeForm.typeName" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogTypeVisible = false">取 消</el-button>
				<el-button type="primary" @click="createActityType">确 定 添 加</el-button>
			</div>
		</el-dialog>
		<!-- 新增成员 -->
		<el-dialog title="新增内部人员" :visible.sync="addDialogFormVisible" :close-on-click-modal='false'>
			<el-table ref="multipleTable" :data="allUsers" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="headerStyle">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column label="姓名" width="120">
					<template slot-scope="scope">{{ scope.row.username }}</template>
				</el-table-column>
				<el-table-column prop="department" label="部门" width="120">
				</el-table-column>
				<el-table-column prop="position" label="职位" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="remark" label="备注" show-overflow-tooltip>
				</el-table-column>
			</el-table>
			<div style="margin: 10px;">
				<el-button type="primary" @click="confirmAdd">确定</el-button>
			</div>
		</el-dialog>

	</div>
</template>
<script>
	import CommonLayout from '../../components/common-layout.vue'
	import dateCanalder from '../../components/calendar.vue'
	import '../../libs/formatDate';
  import {download1} from "@/utils/download";
	export default {
		components: {
			CommonLayout,
			dateCanalder
		},
		data() {
			return {
				allUsers: [], //所有的组织架构人员
				selectUser: [], //要添加的所有成员
				multipleSelection: [], //选中所有成员id
				startRange: '', //具体时间段
				endRange: '',
				operationType: 'add',
				selectDates: [],
				isSelectDate: false, //是否可选择时间
				total: 20,
				current_page: 1,
				per_page: 10,
				headerStyle: {
					color: '#623AA2',
					background: '#E5F3FE'
				},
				dialogTypeVisible: false, //添加活动类型
				acTypeForm: {
					typeName: ''
				},
				acTypeFormRule: {
					typeName: [{
						required: true,
						message: "请填写类型名称",
						trigger: "blur"
					}]
				},
				typeVal: '',
				areaVal: '',
				statusVal: '',
				dateVal: '',
				searchValue: '',
				typeOptions: [],
				addressOptions: [],
				dialogFormVisible: false,
				centerDialogVisible: false,
				form: {
					name: '',
					typeId: '',
					fieldId: '',
					appointmentTime: '',
					time: '',
					unit: '',
					people: '',
					phone: '',
					status: 1,
					startDay: '',
					endDay: '',
					isMessage: 1,
					remark_time: '',
					startTime: '',
					endTime: ''
				},
				innerFormRules: {
					name: [{
						required: true,
						message: '请输入会议名称',
						trigger: 'blur'
					}],
					typeId: [{
						required: true,
						message: '请选择会议类型',
						trigger: 'change'
					}],
					fieldId: [{
						required: true,
						message: '请选择会议室',
						trigger: 'change'
					}],
					time: [{
						type: 'date',
						required: true,
						message: '请选择会议时间',
						trigger: 'change'
					}],
					unit: [{
						required: true,
						message: '请填写预约部门',
						trigger: 'blur'
					}],
					people: [{
						required: true,
						message: '请填写预约人',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请填写联系电话',
						trigger: 'blur'
					}],
					remark_time: [{
						required: true,
						message: '请选择会议时间段',
						trigger: 'blur'
					}]

				},
				formLabelWidth: '120px',
				addDialogFormVisible: false,
				addForm: {
					username: '',
					department: '',
					position: '',
					phone: '',
					remark: '',
					id: ''
				},
				addRules: {
					id: [{
						required: true,
						message: '请输入参会人员姓名',
						trigger: 'blur'
					}],
					department: [{
						required: true,
						message: '请输入参会人员所在单位',
						trigger: 'blur'
					}],
					position: [{
						required: true,
						message: '请输入参会人员职位',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入参会人员电话',
						trigger: 'blur'
					}],
				},
				innerTable: [],
				tableData: [],
				formDesc: {
					desc: ''
				},
				formDescRule: {
					desc: [{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			exportOut(){
				/*let url = window.urlConfig.url + "export_inner_Meeting";
      	var a = document.createElement("a");
      	a.href = url;
      	a.download = "";
      	a.click();*/
        download1(`${urlConfig.devUrl}apij2/admin-api/trade/meeting/export-excel?category=2`, "会议.xls")
			},
			// 得到不能预约的时间
			getuselessDate(fieldId) {
				let startDate = new Date();
				let endDate = new Date();
				endDate.setDate(startDate.getDate() + 30);
        let params = {
          fieldId: fieldId,
          startDay: startDate.format("yyyy-MM-dd"),
          endDay: endDate.format("yyyy-MM-dd")
        }
				this.http.post(
					`${urlConfig.devUrl}apij2/admin-api/trade/meeting/if_appointment`, params
				).then(res => {
					this.selectDates = this.formatDateManage(res.data)
					this.isSelectDate = true
				})
			},

			//处理后台返回的数据
			userSelectData(arr) {
				if (arr.length > 0) {
					this.form.appointmentTime = arr
					this.form.time = new Date()
					this.form.startDay = arr[0].day
					this.form.endDay = arr[arr.length - 1].day
					this.calcTimeRange(arr)
				} else {
					this.form.time = ''
				}
			},
			calcTimeRange(arr) {
				//selectableRange:`00:00:00 -${form.endTime ? form.endTime+':00' : '23:59:00'}`,
				// selectableRange:`${form.startTime ? form.startTime+':00' : '00:00:00'}-23:59:00`

				if (arr.length > 1) {
					this.startRange = '08:00:00'
					this.endRange = '18:00:00'
				} else {
					if (arr[0].noon == 1) {
						this.startRange = '08:00:00'
						this.endRange = '12:00:00'
					} else {
						this.startRange = '12:00:00'
						this.endRange = '18:00:00'
					}
				}
			},
			// 发送短信验证码
			sendMessage(content,phone) {
				this.http.post('code/common_send', {
					content: content,
					phone: phone
				}).then(res => {
			
				})
			},
			submitForm(formName) {
				if (this.form.startTime == '' || this.form.endTime == '' || this.form.startTime == null || this.form.endTime ==
					null) {
					this.form.remark_time = ''
				} else {
					this.form.remark_time = this.form.startTime + ',' + this.form.endTime
					this.form.startTime = this.form.startDay + ' ' + this.form.startTime + ":" + '00'
					this.form.endTime = this.form.endDay + ' ' + this.form.endTime + ":" + '00'
				}

				let arrId = []
				if (this.innerTable.length > 0) {
					this.innerTable.map(item => {
						arrId.push(item.id)
					})
				}
				this.form.partyIds = arrId.join(",");
				this.$refs[formName].validate(valid => {
					if (valid) {
						let tips = `您参加的${this.form,name}会议将于${this.form.startDay} ${this.form.startTime}开始到${this.form.endDay} ${this.form.endTime}结束,请准时参加`
						if (this.operationType == 'add' || this.operationType == 'rePrview') {
							delete this.form.id
							delete this.form.time
							// delete this.form.startTime
							// delete this.form.endTime
							delete this.form.remarkTime
              this.form.category = 2;
							this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting/create`, this.form).then((res) => {
								if (res.code == 0) {
									let message = this.operationType == 'add' ? '新建成功' : '再次预约成功'
									this.$message.success(message);
									this.search()
									this.dialogFormVisible = false;
									if(this.form.isMessage == 1){
										this.sendMessage(tips,this.form.phone)
										let that = this;
										if(this.innerTable.length > 0){
											setTimeout(()=> {
												that.innerTable.map(item => {
													that.sendMessage(tips,item.phone)
												})
											},1000)
										}
									}
									

								} else {
									this.$message.error(res.status)
								}
							})
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 确认添加人员
			confirmAdd() {
				// this.$refs[formName].validate(valid => {
				// 	if (valid) {
				// 		this.innerTable.push({
				// 			id: this.addForm.id,
				// 			phone: this.addForm.phone,
				// 			position: this.addForm.position,
				// 			department: this.addForm.department,
				// 			username: this.addForm.username,
				// 			remark: this.addForm.remark
				// 		})
				// 		this.addDialogFormVisible = false
				// 	} else {
				// 		console.log('error submit!!');
				// 		return false;
				// 	}
				// });
				this.innerTable = this.multipleSelection
				this.addDialogFormVisible = false
			},
			// 添加成员
			addMember() {
				this.addDialogFormVisible = true
				// this.addForm.phone = ''
				// this.addForm.position = ''
				// this.addForm.department = ''
				// this.addForm.username = ''
				// this.addForm.id = ''
				// this.addForm.remark = ''
				this.getUserData()
				//this.multipleSelection = this.innerTable
				
				
			},
			// 删除成员
			deleteInnerRow(index, rows) {
				rows.splice(index, 1);
			},

			// 确认添加备注
			addDesc() {
				this.$refs['formDescRule'].validate(valid => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 打开内部预约
			openInnerModal(row) {
				this.operationType = row ? 'edit' : 'add';
				this.selectDates = []
				this.innerTable = []
				this.dialogFormVisible = true
				this.isSelectDate = false //重新设置日历不可选择 除非先选择场地
        console.log(this.operationType, 112)
				this.resetForm()
				if (row) {
					this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/meeting/get?id=`+row.id).then(res => {
						if (res.code == 0) {
							let result = res.data;
							let endHours = result.endTime?.slice(result.endDay.length)
							let startHours = result.startTime?.slice(result.startDay.length)
							this.form.name = result.name;
							this.form.id = result.id
							this.form.typeId = result.typeId;
							this.form.fieldId = result.fieldId;
							this.form.appointmentTime = result.appointmentTime;
							this.form.time = new Date()
							this.selectDates = this.formatDateManage(result.appointmentTime)
							this.form.unit = result.unit;
							this.form.people = result.people;
							this.form.phone = result.phone;
							this.form.status = result.status;
							this.form.reason = result.reason;
							this.form.startDay = result.startDay;
							this.form.endDay = result.endDay;
							this.form.endTime = endHours.slice(0, endHours.lastIndexOf(':'))
							this.form.startTime = startHours.slice(0, startHours.lastIndexOf(':'))
							this.innerTable = result.partyInfo ? result.partyInfo : []
						} else {
							this.$message.error(res.status)
						}
					})


				}
			},
			//打开添加备注弹框
			openDescModal(index, row) {
				this.centerDialogVisible = true
			},
			// 会议类型
			getTypeData() {
				this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-type/page`, {pageSize: 1000}).then(res => {
					this.typeOptions = res.data.data
				}).catch(err => {
					this.$message.error(err)
				})
			},
			//添加会议类型
			addActityType() {
				this.dialogTypeVisible = true;
				this.acTypeForm.typeName = ''
			},
			// 创建活动类型
			createActityType() {
				this.$refs["acTypeForm"].validate(valid => {
					if (valid) {
						this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-type/create`, this.acTypeForm).then((res) => {
							if (res.code == 0) {
								this.$message.success("添加成功")
								this.dialogTypeVisible = false;
								this.getTypeData()
							}
						}).catch(error => {
							this.$message.error(res.status)
						})
					}
				})

			},
			//场地数据
			getSiteData() {
				this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-field/page`, {pageSize: 1000}).then(res => {
					this.addressOptions = res.data.data
				})
			},
			//获取会议列表
			getData(url) {
        let params = {};
        if(url.indexOf('?') > -1){
          let urlParams = url.split('?')[1]?.split('&')
          urlParams.forEach(item => {
            params[item.split('=')[0]] = item.split('=')[1]
          })
        }

        this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting/page2`, params).then(res => {
					if (res.code == 0) {
						this.tableData = res.data.data
						this.current_page = res.data.current_page
						this.total = res.data.total
						this.per_page = res.data.per_page
					}
				}).catch(err => {
					this.$message.error(err)
				})
			},
			//选择页码
			handleCurrentChange(e) {
				this.current_page = e;
				this.getData(`Meeting?page=${this.current_page}&category=2`);
			},
			//处理时间数据格式
			formatDateManage(dateArrs) {
				var hash = {};
				var i = 0;
				var res = [];
				dateArrs.forEach(function(item) {
					var name = item.day;
					hash[name] ? res[hash[name] - 1].id.push(item.noon) : hash[name] = ++i && res.push({
						id: [item.noon],
						datestr: name,
					})

				});
				let arrs = []
				res.map(items => {
					if (items.id.length == 1) {
						arrs.push({
							am: items.id[0] == 1,
							pm: items.id[0] == 2,
							datestr: items.datestr
						})
					} else {
						arrs.push({
							am: items.id[0] == 1,
							pm: items.id[1] == 2,
							datestr: items.datestr
						})
					}
				})
				return arrs

			},
			// 活动类型
			siteEvent() {
				if (this.form.fieldId) {
					this.getuselessDate(this.form.fieldId)

				}
			},
			resetForm() {
				this.form.name = '';
				this.form.typeId = '';
				this.form.fieldId = '';
				this.form.appointmentTime = '';
				this.form.unit = '';
				this.form.people = '';
				this.form.phone = '';
				this.form.status = 1;
				this.form.startDay = '';
				this.form.endDay = '',
				this.form.number = ''
				this.form.time = ''
				this.remark_time = ''
				this.form.startTime = ''
				this.form.endTime = ''
			},
			// 再次预约
			rePreviewEvent(row) {

				this.operationType = 'rePrview';
				this.selectDates = []
				this.dialogFormVisible = true
				this.resetForm()
				this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/meeting/get?id=${row.id}`).then(res => {
					if (res.code == 0) {
						let result = res.data;
						this.getuselessDate(result.fieldId)
						this.form.name = result.name;
						this.form.id = result.id
						this.form.typeId = result.typeId;
						this.form.fieldId = result.fieldId;
						this.form.appointmentTime = '';
						this.form.time = ''
						this.form.unit = result.unit;
						this.form.people = result.people;
						this.form.phone = result.phone;
						this.form.status = result.status;
						this.form.startDay = result.startDay;
						this.form.endDay = result.endDay;
						this.form.startTime = ''
						this.form.endTime = ''
						this.innerTable = result.partyInfo ? result.partyInfo : []
					} else {
						this.$message.error(res.status)
					}
				})

			},
			//删除预约
			deleteEvent(row) {
				this.$confirm("确定删除预约吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true
					})
					.then(() => {
						this.http.request(`${urlConfig.devUrl}apij2/admin-api/trade/meeting/delete?id=` + row.id, "", "delete").then(
							response => {
								if (response.code == 0) {
									this.$message.success("删除成功！");
									this.search()
								} else {
									this.$message.error(response.status)
								}
							},
							error => {}
						);
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除"
						});
					});
			},
			search() {
				let typeId = this.typeVal ? `&typeId=${this.typeVal}` : '';
				let meeting_status = this.statusVal ? `&meeting_status=${this.statusVal}` : '';
				let fieldId = this.areaVal ? `&fieldId=${this.areaVal}` : '';

				if (this.dateVal) {
					this.getData(
						`Meeting?category=2&name=${this.searchValue}&startDay=${this.dateVal[0]}&endDay=${this.dateVal[1]}${typeId}${meeting_status}${fieldId}`
					)
				} else {
					this.getData(`Meeting?category=2&name=${this.searchValue}${typeId}${meeting_status}${fieldId}`)
				}
			},
			//所有的组织架构人员
			getUserData() {
				// allUsers
				this.$store.dispatch("getUser").then(res => {
					this.allUsers = res.data.data
					let that = this;
					setTimeout(()=>{
						that.toggleSelection(that.innerTable)
					})
				});
			},
			toggleSelection(rows) {
				let that = this;
				this.$refs.multipleTable.clearSelection();
			    for (let j = 0; j < that.allUsers.length; j++) {
			      for (let i = 0; i < rows.length; i++) {
					if (that.allUsers[j].id == rows[i].id) {
						that.$refs.multipleTable.toggleRowSelection(that.allUsers[j]);
					}
			      }
			    }  
			},
			//填充人员信息
			fillUserData() {
				this.findUserData(this.addForm.id, this.allUsers)
			},
			findUserData(id, data) {
				for (let item of data) {
					if (item.id == this.addForm.id) {
						this.addForm.phone = item.phone
						this.addForm.position = item.position
						this.addForm.department = item.department
						this.addForm.username = item.username
						this.addForm.remark = item.remark ? item.remark : '暂无'
					}
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				
			}
		},
		created() {
			this.getTypeData()
			this.getSiteData()
		},
		mounted() {
			this.getData("Meeting?category=2")
		}
	}
</script>
<style lang="scss">
	@include component(inner-filed) {
		width: 100%;
		height: 100%;

		@include part(header) {
			display: flex;
			justify-content: flex-start;

			>section {
				margin-right: 15px;
				margin-left: 15px;

				@include component(el-input) {
					width: 200px;
				}
			}

			@include part(item) {
				display: flex;
				justify-content: flex-start;
				align-items: center;

				>label {
					width: 70px;
					display: inline-block;

				}

				@include component(el-input) {
					width: 150px;
				}

			}
		}

		@include part(searchBtn) {
			margin-left: 10px;
		}

		@include part(addBtn) {
			&:nth-child(2) {
				margin-right: 10px;
			}

			&:nth-child(1) {
				background: #623AA2 !important;
				color: #fff;
				border: none;
			}
		}

		@include part(table) {
			margin-top: 30px;
		}

		@include component(rowItem) {
			width: 50%;
			display: inline-block;

			@include option(detailBtn) {
				@include component(el-form-item__content) {
					width: 100%;
					text-align: left;
				}
			}
		}

		@include component(el-select) {
			width: 100%;
		}

		@include component(el-radio-group) {
			width: 100%;
			text-align: left;
		}

		@include tweak(add-button) {
			@include component(el-form-item__content) {
				display: flex;
				justify-content: flex-start;
			}

			@include component(el-select) {
				width: 220px;
				margin-right: 15px
			}
		}

		@include tweak(date-box) {
			width: 100%;
		}
	}
</style>
